module.exports = __webpack_public_path__ + "66ae38414ec89f9de605b8a20bf2b3ce.png";